// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IeY0","right":"styles_right__2P3ND"};